import {Component} from '@angular/core';

import {FormControl, FormGroup, NgForm, Validators} from '@angular/forms';

import {AuthService} from '../../../core/service/auth.service';
import {ApiService} from '../../../core/service/api.service';

export interface SecurityResponseInterface {
    status: Number;
    msg: String;
}

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html'
})
export class SettingsComponent {

    public securityForm: FormGroup;
    public securityResponse: SecurityResponseInterface;

    public loading: boolean;
    public securityFormSubmitted: boolean;

    constructor(private auth: AuthService, private api: ApiService) {

        this.securityFormCreate();
        this.loading = false;
    }

    securityFormCreate() {
        const user = this.auth.getUser();
        this.securityForm = new FormGroup(
            {
                'username': new FormControl(user['email'], [Validators.required]),
                'current_password': new FormControl('', [Validators.required]),
                'password': new FormControl('', [
                    Validators.required,
                    Validators.pattern('.{8,}')
                ]),
                'repeat_password': new FormControl('', [
                    Validators.required,
                    this.passValidation.bind(this.securityForm)
                ])
            }
        );

    }

    securityFormSubmit() {
        this.securityFormSubmitted = true;

        if (this.securityForm.valid) {
            this.loading = true;
            this.api.post('password/update', this.securityForm.value).subscribe(
                (data) => {
                    this.securityResponse = {
                        status: data['status'],
                        msg: data['msg']
                    };
                    this.loading = false;

                },
                (error) => {
                    this.securityResponse = {
                        status: 0,
                        msg: 'Error, please try again.'
                    }

                    this.loading = false;
                }
            );
        }
    }

    passValidation(control: FormControl): { [s: string]: boolean } {
        if (control.parent) {
            const passwd = control.parent.value.password;
            const rep_passwd = control.value;

            if (passwd !== rep_passwd) {
                return {
                    password_mismatch: true
                }
            }
        }
        return null;
    }
}



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/config/components/settings/settings.component.ts